<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <app-collapse
        accordion
        :type="'margin'"
      >
        <app-collapse-item
          id="collapse-1"
          :is-visible="true"
          :title="$t('Box Properties')"
        >
          <template>
            <b-row>
              <!-- Project Select -->
              <b-col md="6">
                <b-form-group
                  :label="$t('Project')"
                  label-for="mc-project"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Project"
                    rules="required"
                  >
                    <v-select
                      id="vue-select-project"
                      v-model="item.projectId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="optionProject"
                      :reduce="project => project.id"
                      label="projectName"
                      :placeholder="$t('Select project...')"
                      :state="errors.length > 0 ? false : null"
                      :clearable="false"
                      :disabled="item.drilledBy ? true : false"
                      @input="projectChanged"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>

              </b-col>

              <!-- Page Select-->
              <b-col md="6">
                <b-form-group
                  :label="$t('Page')"
                  label-for="mc-parent"
                >
                  <v-select
                    id="vue-select"
                    v-model="item.pageId"
                    :options="optionPage"
                    :reduce="page => page.id"
                    label="title"
                    :clearable="false"
                    :disabled="item.drilledBy ? true : false"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <!-- Box Title -->
              <b-col>
                <b-form-group
                  :label="$t('Box Title')"
                  label-for="mc-box-title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Box Title"
                    rules="required"
                  >
                    <b-form-input
                      v-model="item.boxTitle"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Box Title')"
                      maxlength="100"
                      @input="autoTitleFlag = false"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>

              </b-col>

            </b-row>

            <b-row>
              <!-- Order Number -->
              <b-col>
                <b-form-group
                  :label="$t('Order Number')"
                  label-for="orderNumber"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="OrderNumber"
                    rules="required|between:0,999"
                  >
                    <b-form-input
                      v-model="item.orderNumber"
                      :state="errors.length > 0 ? false : null"
                      :disabled="item.drilledBy ? true : false"
                      :placeholder="$t('Order Number (0-999)')"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Box Width -->
              <b-col>
                <b-form-group
                  :label="$t('Box Width')"
                  label-for="mc-box-width"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Box Width"
                    rules="required"
                  >
                    <v-select
                      id="vue-box-width"
                      v-model="item.boxWidth"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="optionWidth"
                      :placeholder="$t('Select box width...')"
                      :clearable="false"
                      :disabled="item.drilledBy ? true : false"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Box Height -->
              <b-col>
                <b-form-group
                  :label="$t('Box Height')"
                  label-for="mc-box-height"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Box Height"
                    rules="required"
                  >
                    <v-select
                      id="vue-box-height"
                      v-model="item.boxHeight"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="optionHeight"
                      :clearable="false"
                      :disabled="item.drilledBy ? true : false"
                      :placeholder="$t('Select box height...')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- User Groups -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('User Groups')"
                  label-for="mc-user-groups"
                >
                  <v-select
                    id="vue-select-user-groups"
                    v-model="item.userGroups"
                    :options="optionUserGroup"
                    :reduce="group => group.id"
                    label="groupName"
                    :placeholder="$t('Select user groups...')"
                    :disabled="item.drilledBy ? true : false"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Description -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Description')"
                  label-for="mc-description"
                >
                  <b-form-textarea
                    v-model="item.description"
                    :placeholder="$t('Description...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </template>

        </app-collapse-item>
        <app-collapse-item :title="$t('Analysis Properties')">
          <b-row>
            <!-- Type -->
            <b-col>
              <b-form-group
                :label="$t('Type')"
                label-for="mc-box-type"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Type"
                  rules="required"
                >
                  <v-select
                    id="mc-box-type"
                    v-model="item.boxConfig.type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionType"
                    :placeholder="$t('Select...')"
                    :clearable="false"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Min Base -->
            <b-col v-if="item.boxConfig.type != 'external' && item.boxConfig.type != 'custom'">
              <b-form-group
                :label="$t('Min Base')"
                label-for="minBase"
              >
                <b-form-input
                  v-model="item.boxConfig.minBase"
                  :placeholder="$t('Auto')"
                  :type="'number'"
                />
              </b-form-group>
            </b-col>
            <!-- Decimal PLaces -->
            <b-col v-if="item.boxConfig.type != 'external' && item.boxConfig.type != 'custom'">
              <b-form-group
                :label="$t('Decimal Places')"
                label-for="decimalPlaces"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Decimal Places"
                  rules="required|between:0,5"
                >
                  <b-form-input
                    v-model="item.boxConfig.decimalPlaces"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Decimal Places (0-5)')"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Current Year - N -->
            <b-col>
              <b-form-group
                :label="$t('Current Year - N')"
                label-for="currentYearMinusN"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Current Year - N"
                  rules="between:0,20"
                >
                  <b-form-input
                    v-model="item.boxConfig.currentYearMinusN"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('max 20')"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <template v-if="item.boxConfig.type === 'score'">

            <!-- Question Names -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Question Names')"
                  label-for="mc-box-questionNames"
                >
                  <QuestionOrder
                    :id="'questionNames'"
                    v-model="item.boxConfig.questionNames"
                    :options="optionQuestion"
                  />
                  <v-select
                    id="mc-box-questionNames"
                    v-model="item.boxConfig.questionNames"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Info Question Names -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Info Question Names')"
                  label-for="mc-box-infoQuestionNames"
                >
                  <QuestionOrder
                    :id="'infoQuestionNames'"
                    v-model="item.boxConfig.infoQuestionNames"
                    :options="optionQuestion"
                  />
                  <v-select
                    id="mc-box-infoQuestionNames"
                    v-model="item.boxConfig.infoQuestionNames"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Score Definitions -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Score Definition')"
                  label-for="mc-box-scoreDefinitions"
                >
                  <QuestionOrder
                    v-if="2==3"
                    :id="'scoreDefinitions'"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                  />
                  <v-select
                    id="mc-box-scoreDefinitions"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Break By Question Name / Significance Test / Significance Test Type-->
            <!-- Break By Question Name -->
            <b-form-group
              :label="$t('Break By')"
              label-for="mc-box-breakByQuestionName"
            >
              <v-select
                id="mc-box-breakByQuestionName"
                v-model="item.boxConfig.breakByQuestionName"
                :options="optionQuestion"
                :reduce="question => question.questionName"
                label="questionText"
                :placeholder="$t('Select...')"
              />
            </b-form-group>
            <b-row>
              <b-col
                v-if="item.boxConfig.breakByQuestionName"
                md="4"
              >
                <!-- Significance Test -->
                <b-form-group
                  :label="$t('Significance Test')"
                  label-for="mc-box-signTest"
                >
                  <v-select
                    id="mc-box-signTest"
                    v-model="item.boxConfig.sigTest"
                    :options="optionSigTest"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest"
                md="4"
              >
                <!-- Significance Test Type-->
                <b-form-group
                  :label="$t('Test Type')"
                  label-for="mc-box-signTestType"
                >
                  <v-select
                    id="mc-box-signTestType"
                    v-model="item.boxConfig.sigTestType"
                    :options="optionSigTestType"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- noColors -->
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest && item.boxConfig.sigTestType=='Up/Down'"
                md="4"
              >
                <b-form-group
                  :label="$t('No Colors')"
                  label-for="mc-boxconfig-noColors"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-noColors"
                    v-model="item.boxConfig.noColors"
                    class="mt-1"
                    name="mc-boxconfig-noColors"
                    switch
                  >
                    <span v-if="item.boxConfig.noColors">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.noColors">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Show Base / Show General Row / Ignore User Filter On General  / Ignore User Filter N Level -->
            <b-row>
              <!-- Show Base -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Base?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showBase"
                    v-model="item.boxConfig.showBase"
                    class="mt-1"
                    name="mc-boxconfig-showBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show General Row -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show General Row?')"
                  label-for="mc-boxconfig-showGeneral"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showGeneral"
                    v-model="item.boxConfig.showGeneral"
                    class="mt-1"
                    name="mc-boxconfig-showGeneral"
                    switch
                  >
                    <span v-if="item.boxConfig.showGeneral">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showGeneral">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Ignore User Filter On General  -->
              <b-col
                v-if="item.boxConfig.showGeneral"
                md="4"
              >
                <b-form-group
                  :label="$t('Ignore User Filter General Row?')"
                  label-for="mc-boxconfig-ignoreUserFilterOnGeneralRow"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-ignoreUserFilterOnGeneralRow"
                    v-model="item.boxConfig.ignoreUserFilterOnGeneralRow"
                    class="mt-1"
                    name="mc-boxconfig-ignoreUserFilterOnGeneralRow"
                    switch
                  >
                    <span v-if="item.boxConfig.ignoreUserFilterOnGeneralRow">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.ignoreUserFilterOnGeneralRow">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <!-- Compare On General  -->
              <b-col
                v-if="item.boxConfig.showGeneral"
                md="4"
              >
                <b-form-group
                  :label="$t('Compare With General?')"
                  label-for="mc-boxconfig-compareOnGeneral"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-compareOnGeneral"
                    v-model="item.boxConfig.compareOnGeneral"
                    class="mt-1"
                    name="mc-boxconfig-compareOnGeneral"
                    switch
                  >
                    <span v-if="item.boxConfig.compareOnGeneral">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.compareOnGeneral">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Ignore User Filter N Level  -->
            <b-row v-if="item.boxConfig.questionNames.length > 0">
              <b-col>
                <b-form-group
                  :label="$t('Ignore User Filter For N Level')"
                  label-for="ignoreUserFilterNLevel"
                >
                  <b-form-input
                    v-model="item.boxConfig.ignoreUserFilterNLevel"
                    placeholder="0"
                  />
                </b-form-group>

              </b-col>

            </b-row>

            <!-- Order By Hierarchy / Order By Score / Order By Asc-->
            <b-row>
              <!-- Order By Hierarchy -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Order By Hierarchy?')"
                  label-for="mc-boxconfig-orderByHierarchy"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-orderByHierarchy"
                    v-model="item.boxConfig.orderByHierarchy"
                    class="mt-1"
                    name="mc-boxconfig-orderByHierarchy"
                    switch
                  >
                    <span v-if="item.boxConfig.orderByHierarchy">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.orderByHierarchy">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Order By Score -->
              <b-col
                v-if="!item.boxConfig.breakByQuestionName"
                md="4"
              >
                <b-form-group
                  :label="$t('Order By Score?')"
                  label-for="mc-boxconfig-orderByScore"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-orderByScore"
                    v-model="item.boxConfig.orderByScore"
                    class="mt-1"
                    name="mc-boxconfig-orderByScore"
                    switch
                  >
                    <span v-if="item.boxConfig.orderByScore">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.orderByScore">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Order By Asc -->
              <b-col
                v-if="!item.boxConfig.breakByQuestionName && item.boxConfig.orderByScore"
                md="4"
              >
                <b-form-group
                  :label="$t('Order ASC?')"
                  label-for="mc-boxconfig-orderByAsc"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-orderByAsc"
                    v-model="item.boxConfig.orderByAsc"
                    class="mt-1"
                    name="mc-boxconfig-orderByAsc"
                    switch
                  >
                    <span v-if="item.boxConfig.orderByAsc">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.orderByAsc">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Show Cumulative -->
              <b-col
                v-if="item.boxConfig.breakByQuestionName"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Cumulative?')"
                  label-for="mc-boxconfig-showCumulative"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showCumulative"
                    v-model="item.boxConfig.showCumulative"
                    class="mt-1"
                    name="mc-boxconfig-showCumulative"
                    switch
                  >
                    <span v-if="item.boxConfig.showCumulative">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showCumulative">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Show Year To Date -->
              <b-col
                v-if="item.boxConfig.breakByQuestionName"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Year To Date?')"
                  label-for="mc-boxconfig-showYearToDate"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showYearToDate"
                    v-model="item.boxConfig.showYearToDate"
                    class="mt-1"
                    name="mc-boxconfig-showYearToDate"
                    switch
                  >
                    <span v-if="item.boxConfig.showYearToDate">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showYearToDate">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="!item.boxConfig.breakByQuestionName && item.boxConfig.orderByScore">
              <!-- Order by Score Definitions -->
              <b-col>
                <b-form-group
                  :label="$t('Order by Score Definition')"
                  label-for="mc-box-orderByScoreDefinitions"
                >
                  <v-select
                    id="mc-box-orderByScoreDefinitions"
                    v-model="item.boxConfig.orderByScoreGroup"
                    :options="optionScoreDefinitionSelected"
                    placeholder="Select ordering score"
                  />
                </b-form-group>
              </b-col>
              <!-- Show Rank -->
              <!-- Ranking Check -->
              <b-col v-if="item.boxConfig.orderByScoreGroup">
                <b-form-group
                  :label="$t('Show Rank?')"
                  label-for="mc-boxconfig-showRankByScore"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showRankByScore"
                    v-model="item.boxConfig.showRankByScore"
                    class="mt-1"
                    name="mc-boxconfig-showRankByScore"
                    switch
                  >
                    <span v-if="item.boxConfig.showRankByScore">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showRankByScore">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Top N -->
              <b-col>
                <b-form-group
                  :label="$t('Top N Item')"
                  label-for="TopNItem"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="TopNItem"
                    rules="required|between:0,999"
                  >
                    <b-form-input
                      v-model="item.boxConfig.topNItem"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Top N (0-999)')"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row v-if="item.boxConfig.orderByScoreGroup">
              <b-col md="4">
                <!-- min base for rank -->
                <b-form-group
                  :label="$t('Min Base For Rank')"
                  label-for="minBaseForRank"
                >
                  <b-form-input
                    v-model="item.boxConfig.minBaseForRank"
                    :placeholder="$t('Auto')"
                    :type="'number'"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <!-- Weight -->
              <b-col>
                <b-form-group
                  :label="$t('Weight')"
                  label-for="mc-box-weight"
                >
                  <v-select
                    id="mc-box-weight"
                    v-model="item.boxConfig.weightColumn"
                    :options="optionQuestionNumeric"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Show Un-Weighted Base -->
              <b-col v-if="item.boxConfig.weightColumn && item.boxConfig.showBase">
                <b-form-group
                  :label="$t('Show Un-Weighted Base?')"
                  label-for="mc-boxconfig-showUnweightedBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showUnweightedBase"
                    v-model="item.boxConfig.showUnweightedBase"
                    class="mt-1"
                    name="mc-boxconfig-showUnweightedBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showUnweightedBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showUnweightedBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>

            <!-- comparePeriods -->
            <b-row
              v-if="(!item.boxConfig.breakByQuestionName || (item.boxConfig.breakByQuestionName && item.boxConfig.breakByQuestionName !== 'donem'))"
            >
              <!-- Period Comparison -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Compare Periods?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-comparePeriods"
                    v-model="item.boxConfig.comparePeriods"
                    class="mt-1"
                    name="mc-boxconfig-comparePeriods"
                    switch
                  >
                    <span v-if="item.boxConfig.comparePeriods">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.comparePeriods">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

               <!-- Todo: Red/Green -->
              <b-col md="4" v-if="2===3">
                <b-form-group
                  :label="$t('Red/Green?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-redGreen"
                    v-model="item.boxConfig.redGreen"
                    class="mt-1"
                    name="mc-boxconfig-redGreen"
                    switch
                  >
                    <span v-if="item.boxConfig.redGreen">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.redGreen">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
           </b-row>

            <!-- addTrendColor -->
            <b-row v-if="item.boxConfig.breakByQuestionName == 'donem'">
              <!-- Add Trend Color -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Add Trend Color?')"
                  label-for="mc-boxconfig-addTrendColor"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-addTrendColor"
                    v-model="item.boxConfig.addTrendColor"
                    class="mt-1"
                    name="mc-boxconfig-addTrendColor"
                    switch
                  >
                    <span v-if="item.boxConfig.addTrendColor">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.addTrendColor">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- below above target -->
            <b-row>
              <!-- Below Target -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Below Target')"
                  label-for="mc-boxconfig-belowTarget"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-belowTarget"
                    v-model="item.boxConfig.belowTarget"
                    class="mt-1"
                    name="mc-boxconfig-belowTarget"
                    switch
                  >
                    <span v-if="item.boxConfig.belowTarget">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.belowTarget">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Above Target -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Above Target')"
                  label-for="mc-boxconfig-aboveTarget"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-aboveTarget"
                    v-model="item.boxConfig.aboveTarget"
                    class="mt-1"
                    name="mc-boxconfig-aboveTarget"
                    switch
                  >
                    <span v-if="item.boxConfig.aboveTarget">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.aboveTarget">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

          </template>
          <template v-else-if="item.boxConfig.type === 'standard'">

            <!-- Score Definitions -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Score Definition')"
                  label-for="mc-box-scoreDefinitions"
                >
                  <QuestionOrder
                    v-if="2==3"
                    :id="'scoreDefinitions'"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                  />

                  <v-select
                    id="mc-box-scoreDefinitions"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Break By Question Name / Significance Test / Significance Test Type-->
            <!-- Break By Question Name -->
            <b-form-group
              :label="$t('Break By')"
              label-for="mc-box-breakByQuestionName"
            >
              <v-select
                id="mc-box-breakByQuestionName"
                v-model="item.boxConfig.breakByQuestionName"
                :options="optionQuestion"
                :reduce="question => question.questionName"
                label="questionText"
                :placeholder="$t('Select...')"
              />
            </b-form-group>
            <b-row>
              <b-col
                v-if="item.boxConfig.breakByQuestionName"
                md="4"
              >
                <!-- Significance Test -->
                <b-form-group
                  :label="$t('Significance Test')"
                  label-for="mc-box-signTest"
                >
                  <v-select
                    id="mc-box-signTest"
                    v-model="item.boxConfig.sigTest"
                    :options="optionSigTest"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest"
                md="4"
              >
                <!-- Significance Test Type-->
                <b-form-group
                  :label="$t('Test Type')"
                  label-for="mc-box-signTestType"
                >
                  <v-select
                    id="mc-box-signTestType"
                    v-model="item.boxConfig.sigTestType"
                    :options="optionSigTestType"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- noColors -->
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest && item.boxConfig.sigTestType=='Up/Down'"
                md="4"
              >
                <b-form-group
                  :label="$t('No Colors')"
                  label-for="mc-boxconfig-noColors"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-noColors"
                    v-model="item.boxConfig.noColors"
                    class="mt-1"
                    name="mc-boxconfig-noColors"
                    switch
                  >
                    <span v-if="item.boxConfig.noColors">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.noColors">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Show Base / Show Cumulative-->
            <b-row>
              <!-- Show Base -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Base?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showBase"
                    v-model="item.boxConfig.showBase"
                    class="mt-1"
                    name="mc-boxconfig-showBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Cumulative -->
              <b-col v-if="item.boxConfig.breakByQuestionName">
                <b-form-group
                  :label="$t('Show Cumulative?')"
                  label-for="mc-boxconfig-showCumulative"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showCumulative"
                    v-model="item.boxConfig.showCumulative"
                    class="mt-1"
                    name="mc-boxconfig-showCumulative"
                    switch
                  >
                    <span v-if="item.boxConfig.showCumulative">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showCumulative">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Show Year To Date -->
              <b-col v-if="item.boxConfig.breakByQuestionName">
                <b-form-group
                  :label="$t('Show Year To Date?')"
                  label-for="mc-boxconfig-showYearToDate"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showYearToDate"
                    v-model="item.boxConfig.showYearToDate"
                    class="mt-1"
                    name="mc-boxconfig-showYearToDate"
                    switch
                  >
                    <span v-if="item.boxConfig.showYearToDate">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showYearToDate">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Weight -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Weight')"
                  label-for="mc-box-weight"
                >
                  <v-select
                    id="mc-box-weight"
                    v-model="item.boxConfig.weightColumn"
                    :options="optionQuestionNumeric"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Show Un-Weighted Base -->
              <b-col v-if="item.boxConfig.weightColumn && item.boxConfig.showBase">
                <b-form-group
                  :label="$t('Show Un-Weighted Base?')"
                  label-for="mc-boxconfig-showUnweightedBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showUnweightedBase"
                    v-model="item.boxConfig.showUnweightedBase"
                    class="mt-1"
                    name="mc-boxconfig-showUnweightedBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showUnweightedBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showUnweightedBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>

          </template>
          <template v-else-if="item.boxConfig.type === 'frequency'">

            <!-- Question Name -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Question')"
                  label-for="mc-box-questionName"
                >
                  <v-select
                    id="mc-box-questionName"
                    v-model="item.boxConfig.questionName"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    @input="handlePercentage"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Visible Options -->
            <b-row v-if="optionQuestionChoice.length">
              <b-col>
                <b-form-group
                  :label="$t('Visible Options')"
                  label-for="mc-box-questionName"
                >
                  <v-select
                    id="vue-select-question-option"
                    v-model="item.boxConfig.visibleOptions"
                    :options="optionQuestionChoice"
                    :reduce="option => option.optionText"
                    label="optionText"
                    :placeholder="$t('All')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Break By Question Name / Significance Test / Significance Test Type-->
            <!-- Break By Question Name -->
            <b-form-group
              :label="$t('Break By')"
              label-for="mc-box-breakByQuestionName"
            >
              <v-select
                id="mc-box-breakByQuestionName"
                v-model="item.boxConfig.breakByQuestionName"
                :options="optionQuestion"
                :reduce="question => question.questionName"
                label="questionText"
                :placeholder="$t('Select...')"
                @input="handlePercentage"
              />
            </b-form-group>
            <b-row>
              <b-col
                v-if="item.boxConfig.breakByQuestionName"
                md="4"
              >
                <!-- Significance Test -->
                <b-form-group
                  :label="$t('Significance Test')"
                  label-for="mc-box-signTest"
                >
                  <v-select
                    id="mc-box-signTest"
                    v-model="item.boxConfig.sigTest"
                    :options="optionSigTest"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest"
                md="4"
              >
                <!-- Significance Test Type-->
                <b-form-group
                  :label="$t('Test Type')"
                  label-for="mc-box-signTestType"
                >
                  <v-select
                    id="mc-box-signTestType"
                    v-model="item.boxConfig.sigTestType"
                    :options="optionSigTestType"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- noColors -->
              <b-col
                v-if="item.boxConfig.breakByQuestionName && item.boxConfig.sigTest && item.boxConfig.sigTestType=='Up/Down'"
                md="4"
              >
                <b-form-group
                  :label="$t('No Colors')"
                  label-for="mc-boxconfig-noColors"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-noColors"
                    v-model="item.boxConfig.noColors"
                    class="mt-1"
                    name="mc-boxconfig-noColors"
                    switch
                  >
                    <span v-if="item.boxConfig.noColors">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.noColors">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Order By Hierarchy / Order By Score / Order By Asc-->
            <b-row>
              <!-- Order By Score -->
              <b-col
                v-if="!item.boxConfig.breakByQuestionName"
                md="4"
              >
                <b-form-group
                  :label="$t('Order By Value?')"
                  label-for="mc-boxconfig-orderByScore"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-orderByScore"
                    v-model="item.boxConfig.orderByScore"
                    class="mt-1"
                    name="mc-boxconfig-orderByScore"
                    switch
                  >
                    <span v-if="item.boxConfig.orderByScore">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.orderByScore">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Order By Asc -->
              <b-col
                v-if="!item.boxConfig.breakByQuestionName && item.boxConfig.orderByScore"
                md="4"
              >
                <b-form-group
                  :label="$t('Order ASC?')"
                  label-for="mc-boxconfig-orderByAsc"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-orderByAsc"
                    v-model="item.boxConfig.orderByAsc"
                    class="mt-1"
                    name="mc-boxconfig-orderByAsc"
                    switch
                  >
                    <span v-if="item.boxConfig.orderByAsc">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.orderByAsc">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Top N -->
              <b-col
                v-if="!item.boxConfig.breakByQuestionName && item.boxConfig.orderByScore"
                md="4"
              >
                <b-form-group
                  :label="$t('Top N Item')"
                  label-for="TopNItem"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="TopNItem"
                    rules="required|between:0,999"
                  >
                    <b-form-input
                      v-model="item.boxConfig.topNItem"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Top N (0-999)')"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Top / Bottom / Percent-->
            <b-row>
              <b-col v-if="selectedQuestionType == 1 || selectedQuestionType == 4">
                <!-- Top -->
                <b-form-group
                  :label="$t('Top')"
                  label-for="mc-box-top"
                >
                  <v-select
                    id="mc-box-top"
                    v-model="item.boxConfig.top"
                    :taggable="true"
                    :options="optionTopBottom"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="selectedQuestionType == 1 || selectedQuestionType == 4">
                <!-- Bottom -->
                <b-form-group
                  :label="$t('Bottom')"
                  label-for="mc-box-bottom"
                >
                  <v-select
                    id="mc-box-bottom"
                    v-model="item.boxConfig.bottom"
                    :taggable="true"
                    :options="optionTopBottom"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <!-- Percent -->
                <b-form-group
                  :label="$t('Percentage')"
                  label-for="mc-box-percentage"
                >
                  <v-select
                    id="mc-box-percentage"
                    v-model="item.boxConfig.percentage"
                    :options="optionPercent"
                    :placeholder="$t('Select...')"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>

            </b-row>

            <b-row v-if="item.boxConfig.percentage != 'no'">
              <!-- Show Base -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Base?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showBase"
                    v-model="item.boxConfig.showBase"
                    class="mt-1"
                    name="mc-boxconfig-showBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Options Base -->
              <b-col
                v-if="item.boxConfig.showBase"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Options Base?')"
                  label-for="mc-boxconfig-showOptionsBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showOptionsBase"
                    v-model="item.boxConfig.showOptionsBase"
                    class="mt-1"
                    name="mc-boxconfig-showOptionsBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showOptionsBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showOptionsBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>
              <!-- Weight -->
              <b-col>
                <b-form-group
                  :label="$t('Weight')"
                  label-for="mc-box-weight"
                >
                  <v-select
                    id="mc-box-weight"
                    v-model="item.boxConfig.weightColumn"
                    :options="optionQuestionNumeric"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Show Un-Weighted Base Wgt-->
              <b-col
                v-if="item.boxConfig.weightColumn && item.boxConfig.percentage === 'by base'"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Un-Weighted Base?')"
                  label-for="mc-boxconfig-showUnweightedBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showUnweightedBase"
                    v-model="item.boxConfig.showUnweightedBase"
                    class="mt-1"
                    name="mc-boxconfig-showUnweightedBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showUnweightedBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showUnweightedBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Show Base Column / Show Total Response Row / Show Options-->
            <b-row class="mt-1 mb-1">
              <!-- Show Base Column -->
              <b-col v-if="item.boxConfig.breakByQuestionName">
                <b-form-group
                  :label="$t('Show Base Column?')"
                  label-for="mc-boxconfig-showBaseColumn"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showBaseColumn"
                    v-model="item.boxConfig.showBaseColumn"
                    class="mt-1"
                    name="mc-boxconfig-showBaseColumn"
                    switch
                  >
                    <span v-if="item.boxConfig.showBaseColumn">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showBaseColumn">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Cumulative -->
              <b-col v-if="item.boxConfig.breakByQuestionName">
                <b-form-group
                  :label="$t('Show Cumulative?')"
                  label-for="mc-boxconfig-showCumulative"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showCumulative"
                    v-model="item.boxConfig.showCumulative"
                    class="mt-1"
                    name="mc-boxconfig-showCumulative"
                    switch
                  >
                    <span v-if="item.boxConfig.showCumulative">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showCumulative">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Show Year To Date -->
              <b-col v-if="item.boxConfig.breakByQuestionName">
                <b-form-group
                  :label="$t('Show Year To Date?')"
                  label-for="mc-boxconfig-showYearToDate"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showYearToDate"
                    v-model="item.boxConfig.showYearToDate"
                    class="mt-1"
                    name="mc-boxconfig-showYearToDate"
                    switch
                  >
                    <span v-if="item.boxConfig.showYearToDate">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showYearToDate">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Show Total Response Row -->
              <b-col v-if="selectedQuestionType === 4">
                <b-form-group
                  :label="$t('Show Total Responses Row?')"
                  label-for="mc-boxconfig-showTotalResponseRow"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showTotalResponseRow"
                    v-model="item.boxConfig.showTotalResponseRow"
                    class="mt-1"
                    name="mc-boxconfig-showTotalResponseRow"
                    switch
                  >
                    <span v-if="item.boxConfig.showTotalResponseRow">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showTotalResponseRow">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Include List Data / Show Mean / Max Value For Average -->
            <b-row>

              <!-- Include List Data -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Include List Data?')"
                  label-for="mc-boxconfig-includeListData"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-includeListData"
                    v-model="item.boxConfig.includeListData"
                    class="mt-1"
                    name="mc-boxconfig-includeListData"
                    switch
                  >
                    <span v-if="item.boxConfig.includeListData">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.includeListData">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Mean -->
              <b-col
                v-if="selectedQuestionType != 0"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Mean?')"
                  label-for="mc-boxconfig-showMean"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showMean"
                    v-model="item.boxConfig.showMean"
                    class="mt-1"
                    name="mc-boxconfig-showMean"
                    switch
                  >
                    <span v-if="item.boxConfig.showMean">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showMean">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Mean -->
              <b-col
                v-if="selectedQuestionType != 0 && item.boxConfig.showMean"
                md="4"
              >
                <b-form-group
                  :label="$t('Mean Only?')"
                  label-for="mc-boxconfig-meanOnly"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-meanOnly"
                    v-model="item.boxConfig.meanOnly"
                    class="mt-1"
                    name="mc-boxconfig-meanOnly"
                    switch
                  >
                    <span v-if="item.boxConfig.meanOnly">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.meanOnly">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Stdev -->
              <b-col
                v-if="selectedQuestionType != 0 && !item.boxConfig.meanOnly"
                md="4"
              >
                <b-form-group
                  :label="$t('Show StdDev?')"
                  label-for="mc-boxconfig-showStdDev"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showStdDev"
                    v-model="item.boxConfig.showStdDev"
                    class="mt-1"
                    name="mc-boxconfig-showStdDev"
                    switch
                  >
                    <span v-if="item.boxConfig.showStdDev">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showStdDev">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- Max Value For Average -->
              <b-col
                v-if="(item.boxConfig.showMean || item.boxConfig.showStdDev) && selectedQuestionType != 0"
                md="4"
              >
                <b-form-group
                  :label="$t('Max Value For Average/Stdev')"
                  label-for="mc-boxconfig-maxValueForAverage"
                >
                  <b-form-input
                    v-model="item.boxConfig.maxValueForAverage"
                    :placeholder="$t('Max Value For Average')"
                  />
                </b-form-group>
              </b-col>
              <!-- Ignore User Filter  -->
              <b-col md="4">
                <b-form-group
                  :label="$t('Ignore User Filter?')"
                  label-for="mc-boxconfig-ignoreUserFilterForFreq"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-ignoreUserFilterForFreq"
                    v-model="item.boxConfig.ignoreUserFilterForFreq"
                    class="mt-1"
                    name="mc-boxconfig-ignoreUserFilterForFreq"
                    switch
                  >
                    <span v-if="item.boxConfig.ignoreUserFilterForFreq">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.ignoreUserFilterForFreq">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
          <template v-else-if="item.boxConfig.type === 'data'">

            <!-- Question Names -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Questions')"
                  label-for="mc-box-questionNames"
                >
                  <QuestionOrder
                    :id="'questionNames2'"
                    v-model="item.boxConfig.questionNames"
                    :options="optionQuestion"
                  />
                  <v-select
                    id="mc-box-questionNames"
                    v-model="item.boxConfig.questionNames"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Score Definitions -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Score Definition')"
                  label-for="mc-box-scoreDefinitions"
                >
                  <QuestionOrder
                    v-if="2==3"
                    :id="'scoreDefinitions'"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                  />

                  <v-select
                    id="mc-box-scoreDefinitions"
                    v-model="item.boxConfig.groupNames"
                    :options="optionScoreDefinition"
                    :placeholder="$t('Select...')"
                    multiple
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Include List Data -->
            <b-row>
              <b-col md="4">
                <b-form-group
                  :label="$t('Include List Data?')"
                  label-for="mc-boxconfig-includeListData"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-includeListData"
                    v-model="item.boxConfig.includeListData"
                    class="mt-1"
                    name="mc-boxconfig-includeListData"
                    switch
                  >
                    <span v-if="item.boxConfig.includeListData">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.includeListData">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('Check Multimedia')"
                  label-for="mc-boxconfig-checkMultiMedia"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-checkMultiMedia"
                    v-model="item.boxConfig.checkMultiMedia"
                    class="mt-1"
                    name="mc-boxconfig-checkMultiMedia"
                    switch
                  >
                    <span v-if="item.boxConfig.checkMultiMedia">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.checkMultiMedia">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

          </template>
          <template v-else-if="item.boxConfig.type === 'external'">
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('External Data')"
                  label-for="externalData"
                >
                  <b-form-textarea
                    v-model="externalDataPaste"
                    :placeholder="$t('Paste your tabular data here...')"
                    @input="parseTabularData"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>

                <b-table
                  v-if="item.boxConfig.externalData"
                  :sticky-header="true"
                  :no-border-collapse="true"
                  responsive
                  :items="item.boxConfig.externalData.items"
                  :fields="item.boxConfig.externalData.fields"
                />
              </b-col>
            </b-row>
          </template>
          <template v-else-if="item.boxConfig.type === 'infographicGroup'">
            <b-row>
              <!-- Layout -->
              <b-col>
                <b-form-group
                  :label="$t('Layout')"
                  label-for="mc-box-layout"
                >
                  <v-select
                    id="mc-box-layout"
                    v-model="item.boxConfig.layout"
                    :options="optionLayout"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- infographics -->
            <div v-if="item.boxConfig.infographics && item.boxConfig.infographics.length > 0">
              <h5 class="mt-1">
                {{ $t('Infographics') }}
              </h5>
              <b-card>

                <b-list-group>

                  <draggable
                    v-model="item.boxConfig.infographics"
                    class="cursor-move"
                  >
                    <b-list-group-item
                      v-for="(igItem, index) in item.boxConfig.infographics"
                      :key="index"
                      href="#"
                      class="flex-column align-items-start"
                      @click="editInfographicItem(igItem, index)"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">
                          <b-badge
                            v-if="item.boxConfig.layout !== 'donut'"
                            :variant="igItem.statisticVariant || 'light-success'"
                          ><feather-icon
                            size="24"
                            :icon="igItem.statisticIcon"
                          /></b-badge>
                          {{ igItem.groupName || (getQuestion(igItem.questionName) &&
                            getQuestion(igItem.questionName).questionText) }}
                        </h5>
                        <small>
                          <b-link @click="deleteInfographicItem(index)">{{ $t('Delete') }}</b-link>
                        </small>
                      </div>

                      <p class="mb-1">
                        {{ igItem.statisticType }} {{ igItem.statisticText }}
                      </p>

                      <small v-if="igItem.columnOperator">{{ igItem.columnOperator }} {{ igItem.statisticOption
                      }}</small>
                    </b-list-group-item>
                  </draggable>

                </b-list-group>

              </b-card>
            </div>

            <!-- One Infographic -->
            <h5
              ref="InfographicForm"
              class="mt-1"
            >
              <template v-if="editInfographicIndex === -1">
                {{ $t('Add Infographic') }}
              </template>
              <template v-if="editInfographicIndex > -1">
                {{ $t('Edit Infographic') }}
              </template>

            </h5>

            <b-row>
              <!-- Statistic Type -->
              <b-col col="6">
                <b-form-group
                  :label="$t('Statistic Type')"
                  label-for="mc-box-statisticType"
                >
                  <v-select
                    id="mc-box-statisticType"
                    v-model="ig.statisticType"
                    :options="optionStatisticType"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- Statistic Size -->
              <b-col col="6">
                <b-form-group
                  :label="$t('Statistic Size')"
                  label-for="mc-box-statisticSize"
                >
                  <v-select
                    id="mc-box-statisticSize"
                    v-model="ig.size"
                    :options="optionStatisticSize"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Question Name -->
            <b-row v-if="ig.statisticType === 'frequency'">
              <b-col>
                <b-form-group
                  :label="$t('Question')"
                  label-for="mc-box-questionName"
                >
                  <v-select
                    id="mc-box-questionName"
                    v-model="ig.questionName"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    @input="ig_getQuestionChoiceOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="ig.statisticType === 'frequency' && ig.questionName">
              <!-- Column Operator -->
              <b-col cols="6">
                <b-form-group
                  :label="$t('Column Operator')"
                  label-for="mc-box-columnOperator"
                >
                  <v-select
                    id="mc-box-columnOperator"
                    v-model="ig.columnOperator"
                    :options="ig_optionColumnOperator"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- Statistic Option -->
              <b-col
                v-if="ig_selectedQuestionType > -1 && (ig.columnOperator === 'Count' || ig.columnOperator === 'Percent')"
                cols="6"
              >
                <b-form-group
                  :label="$t('Statistic Option')"
                  label-for="mc-box-statisticOption"
                >
                  <v-select
                    id="mc-box-statisticOption"
                    v-model="ig.statisticOption"
                    :options="ig_optionQuestionChoice"
                    :reduce="option => option.optionValue"
                    label="optionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Score Name -->
            <b-row v-if="ig.statisticType === 'score'">
              <b-col>
                <b-form-group
                  :label="$t('Score Definition')"
                  label-for="mc-box-scoreDefinition"
                >
                  <v-select
                    id="mc-box-scoreDefinition"
                    v-model="ig.groupName"
                    :options="optionScoreDefinition"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Show Base -->
            <b-row>
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Base?')"
                  label-for="ig-showBase"
                >
                  <b-form-checkbox
                    id="ig-showBase"
                    v-model="ig.showBase"
                    class="mt-1"
                    name="ig-showBase"
                    switch
                  >
                    <span v-if="ig.showBase">{{ $t('Yes') }}</span>
                    <span v-if="!ig.showBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Include List Data -->
              <b-col
                v-if="ig.statisticType === 'frequency'"
                md="4"
              >
                <b-form-group
                  :label="$t('Include List Data?')"
                  label-for="ig-includeListData"
                >
                  <b-form-checkbox
                    id="ig-includeListData"
                    v-model="ig.includeListData"
                    class="mt-1"
                    name="ig-includeListData"
                    switch
                  >
                    <span v-if="ig.includeListData">{{ $t('Yes') }}</span>
                    <span v-if="!ig.includeListData">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>

            <!-- Weight -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Weight')"
                  label-for="mc-box-weight"
                >
                  <v-select
                    id="mc-box-weight"
                    v-model="item.boxConfig.weightColumn"
                    :options="optionQuestionNumeric"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Statistic Icon -->
            <b-form-group
              v-if="item.boxConfig.layout !== 'donut'"
              :label="$t('Statistic Icon')"
              label-for="mc-statistic-icon"
            >
              <b-card
                class="icon-card cursor-pointer text-center mb-2 mx-50"
                @click="selectIcon"
              >
                <div class="icon-wrapper">
                  <b-avatar
                    size="48"
                    :variant="ig.statisticVariant || 'light-success'"
                  >
                    <feather-icon
                      size="24"
                      :icon="ig.statisticIcon"
                    />
                  </b-avatar>
                </div>
                <b-card-text class="icon-name text-truncate mb-0 mt-1">
                  {{ ig.statisticIcon }}
                </b-card-text>
              </b-card>
            </b-form-group>

            <b-row>
              <!-- Statistic Variant -->
              <b-col>
                <b-form-group
                  :label="$t('Color')"
                  label-for="mc-box-statisticVariant"
                >
                  <v-select
                    id="mc-box-statisticVariant"
                    v-model="ig.statisticVariant"
                    :options="optionStatisticVariant"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- Statistic Text -->
              <b-col>
                <b-form-group
                  :label="$t('Text')"
                  label-for="mc-box-statisticText"
                >
                  <b-form-input
                    v-model="ig.statisticText"
                    :placeholder="$t('Text...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <icon-selector @selected="ig_setIcon" />

            <b-button
              variant="primary"
              @click="addInfographic"
            >
              <template v-if="editInfographicIndex === -1">
                {{ $t('Add') }}
              </template>
              <template v-if="editInfographicIndex > -1">
                {{ $t('Update') }}
              </template>

            </b-button>

            <b-button
              v-if="editInfographicIndex > -1"
              class="ml-1"
              variant="secondary"
              @click="resetEditingInfographic"
            >
              {{ $t('Cancel') }}
            </b-button>

            <!-- TODO: Ignore User Filter -->
            <b-row class="mt-2" v-if="2===3">
              <b-col>
                <b-form-group
                  :label="$t('Ignore User Filter?')"
                  label-for="mc-boxconfig-IgnoreUserFilter"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-IgnoreUserFilter"
                    v-model="item.boxConfig.IgnoreUserFilter"
                    name="mc-boxconfig-IgnoreUserFilter"
                    switch
                  >
                    <span v-if="item.boxConfig.IgnoreUserFilter">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.IgnoreUserFilter">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
          <template v-else-if="item.boxConfig.type === 'infographic'">

            <b-row>
              <!-- Statistic Type -->
              <b-col md="6">
                <b-form-group
                  :label="$t('Statistic Type')"
                  label-for="mc-box-statisticType"
                >
                  <v-select
                    id="mc-box-statisticType"
                    v-model="item.boxConfig.statisticType"
                    :options="optionStatisticType"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Layout -->
              <b-col md="6">
                <b-form-group
                  :label="$t('Layout')"
                  label-for="mc-box-layout"
                >
                  <v-select
                    id="mc-box-layout"
                    v-model="item.boxConfig.layout"
                    :options="optionLayoutWithMap"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Question Name -->
            <b-row v-if="item.boxConfig.statisticType === 'frequency'">
              <b-col>
                <b-form-group
                  :label="$t('Question')"
                  label-for="mc-box-questionName"
                >
                  <v-select
                    id="mc-box-questionName"
                    v-model="item.boxConfig.questionName"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    @input="getQuestionChoiceOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="item.boxConfig.statisticType === 'frequency' && item.boxConfig.questionName">
              <!-- Column Operator -->
              <b-col cols="6">
                <b-form-group
                  :label="$t('Column Operator')"
                  label-for="mc-box-columnOperator"
                >
                  <v-select
                    id="mc-box-columnOperator"
                    v-model="item.boxConfig.columnOperator"
                    :options="optionColumnOperator"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
              <!-- Statistic Option -->
              <b-col
                v-if="selectedQuestionType > -1 && (item.boxConfig.columnOperator === 'Count' || item.boxConfig.columnOperator === 'Percent')"
                cols="6"
              >
                <b-form-group
                  :label="$t('Statistic Option')"
                  label-for="mc-box-statisticOption"
                >
                  <v-select
                    id="mc-box-statisticOption"
                    v-model="item.boxConfig.statisticOption"
                    :options="optionQuestionChoice"
                    :reduce="option => option.optionValue"
                    label="optionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Score Name -->
            <b-row v-if="item.boxConfig.statisticType === 'score'">
              <b-col>
                <b-form-group
                  :label="$t('Score Definition')"
                  label-for="mc-box-scoreDefinition"
                >
                  <v-select
                    id="mc-box-scoreDefinition"
                    v-model="item.boxConfig.groupName"
                    :options="optionScoreDefinition"
                    :placeholder="$t('Select...')"
                    @input="handleTitle"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Map Group By -->
            <b-row v-if="item.boxConfig.layout === 'map-tr'">
              <b-col>
                <b-form-group
                  :label="$t('Group By')"
                  label-for="mc-box-mapGroupBy"
                >
                  <v-select
                    id="mc-box-mapGroupBy"
                    v-model="item.boxConfig.mapGroupBy"
                    :options="optionQuestion"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                    @input="getQuestionChoiceOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Show Base -->
            <b-row>
              <b-col md="4">
                <b-form-group
                  :label="$t('Show Base?')"
                  label-for="mc-boxconfig-showBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showBase"
                    v-model="item.boxConfig.showBase"
                    class="mt-1"
                    name="mc-boxconfig-showBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Show Un-Weighted Base -->
              <b-col
                v-if="item.boxConfig.weightColumn"
                md="4"
              >
                <b-form-group
                  :label="$t('Show Un-Weighted Base?')"
                  label-for="mc-boxconfig-showUnweightedBase"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-showUnweightedBase"
                    v-model="item.boxConfig.showUnweightedBase"
                    class="mt-1"
                    name="mc-boxconfig-showUnweightedBase"
                    switch
                  >
                    <span v-if="item.boxConfig.showUnweightedBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.showUnweightedBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Include List Data -->
              <b-col
                v-if="item.boxConfig.statisticType === 'frequency'"
                md="4"
              >
                <b-form-group
                  :label="$t('Include List Data?')"
                  label-for="mc-boxconfig-includeListData"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-includeListData"
                    v-model="item.boxConfig.includeListData"
                    class="mt-1"
                    name="mc-boxconfig-includeListData"
                    switch
                  >
                    <span v-if="item.boxConfig.includeListData">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.includeListData">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>

            <!-- Weight -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Weight')"
                  label-for="mc-box-weight"
                >
                  <v-select
                    id="mc-box-weight"
                    v-model="item.boxConfig.weightColumn"
                    :options="optionQuestionNumeric"
                    :reduce="question => question.questionName"
                    label="questionText"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <template v-if="item.boxConfig.layout !== 'map-tr'">
              <!-- Statistic Icon -->
              <b-form-group
                v-if="item.boxConfig.layout !== 'donut'"
                :label="$t('Statistic Icon')"
                label-for="mc-statistic-icon"
              >
                <b-card
                  class="icon-card cursor-pointer text-center mb-2 mx-50"
                  @click="selectIcon"
                >
                  <div class="icon-wrapper">
                    <b-avatar
                      size="48"
                      :variant="item.boxConfig.statisticVariant || 'light-success'"
                    >
                      <feather-icon
                        size="24"
                        :icon="item.boxConfig.statisticIcon"
                      />
                    </b-avatar>
                  </div>
                  <b-card-text class="icon-name text-truncate mb-0 mt-1">
                    {{ item.boxConfig.statisticIcon }}
                  </b-card-text>
                </b-card>
              </b-form-group>

              <b-row>
                <!-- Statistic Variant -->
                <b-col>
                  <b-form-group
                    :label="$t('Color')"
                    label-for="mc-box-statisticVariant"
                  >
                    <v-select
                      id="mc-box-statisticVariant"
                      v-model="item.boxConfig.statisticVariant"
                      :options="optionStatisticVariant"
                      :placeholder="$t('Select...')"
                    />
                  </b-form-group>
                </b-col>
                <!-- Statistic Text -->
                <b-col>
                  <b-form-group
                    :label="$t('Text')"
                    label-for="mc-box-statisticText"
                  >
                    <b-form-input
                      v-model="item.boxConfig.statisticText"
                      :placeholder="$t('Text...')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <icon-selector @selected="setIcon" />
            </template>

            <template v-if="item.boxConfig.layout === 'map-tr'">

              <!-- Compare with general -->
              <b-form-group
                :label="$t('Compare with general')"
                label-for="mc-boxconfig-compareWithGeneral"
              >
                <b-form-checkbox
                  id="mc-boxconfig-compareWithGeneral"
                  v-model="item.boxConfig.compareWithGeneral"
                  class="mt-1"
                  name="mc-boxconfig-compareWithGeneral"
                  switch
                >
                  <span v-if="item.boxConfig.compareWithGeneral">
                    {{ $t('Yes') }}
                  </span>
                  <span v-if="!item.boxConfig.compareWithGeneral">
                    {{ $t('No') }}
                  </span>
                </b-form-checkbox>
              </b-form-group>

              <template v-if="item.boxConfig.compareWithGeneral">
                <b-row>
                  <b-col>
                    <b-form-group
                      :label="$t('Color Below')"
                      label-for="colorBelow"
                    >
                      <b-form-input
                        v-model="item.boxConfig.colorBelow"
                        type="color"
                        :placeholder="$t('Color...')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group
                      :label="$t('Color Above')"
                      label-for="colorAbove"
                    >
                      <b-form-input
                        v-model="item.boxConfig.colorAbove"
                        type="color"
                        :placeholder="$t('Color...')"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <!-- color steps -->
                <h5 class="mt-1">
                  {{ $t('Color Steps') }}
                </h5>
                <b-row>
                  <!-- From -->
                  <b-col>
                    <b-form-group
                      :label="$t('From')"
                      label-for="from"
                    >
                      <b-form-input
                        v-model="colorStep.from"
                        type="number"
                        :placeholder="$t('From...')"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- To -->
                  <b-col>
                    <b-form-group
                      :label="$t('To')"
                      label-for="to"
                    >
                      <b-form-input
                        v-model="colorStep.to"
                        type="number"
                        :placeholder="$t('To...')"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- Name -->
                  <b-col>
                    <b-form-group
                      :label="$t('Name')"
                      label-for="name"
                    >
                      <b-form-input
                        v-model="colorStep.name"
                        :placeholder="$t('Name...')"
                      />
                    </b-form-group>

                  </b-col>
                  <!-- Color -->
                  <b-col>
                    <b-form-group
                      :label="$t('Color')"
                      label-for="color"
                    >
                      <b-form-input
                        v-model="colorStep.color"
                        type="color"
                        :placeholder="$t('Color...')"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Button -->
                  <b-col>
                    <b-button
                      class="mt-2"
                      variant="primary"
                      @click="addColorStep"
                    >
                      {{ $t('OK') }}
                    </b-button>
                  </b-col>
                </b-row>
                <b-list-group v-if="item.boxConfig.colorSteps && item.boxConfig.colorSteps.length > 0">

                  <draggable
                    v-model="item.boxConfig.colorSteps"
                    class="cursor-move"
                  >
                    <b-list-group-item
                      v-for="(step, index) in item.boxConfig.colorSteps"
                      :key="index"
                      class="flex-column align-items-start"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">
                          <b-badge
                            :style="'background-color:' + step.color"
                            class="mr-1"
                          >&nbsp;
                          </b-badge>{{ step.name }}
                          <small class="ml-1">{{ step.from }} - {{ step.to }}</small>
                        </h5>
                        <small>
                          <b-link @click="removeColorStep(index)">{{ $t('delete') }}</b-link>
                        </small>
                      </div>
                    </b-list-group-item>
                  </draggable>

                </b-list-group>
              </template>
            </template>

            <!-- TODO: Ignore User Filter -->
            <b-row class="mt-2" v-if="2===3">
              <b-col>
                <b-form-group
                  :label="$t('Ignore User Filter?')"
                  label-for="mc-boxconfig-IgnoreUserFilter"
                >
                  <b-form-checkbox
                    id="mc-boxconfig-IgnoreUserFilter"
                    v-model="item.boxConfig.IgnoreUserFilter"
                    name="mc-boxconfig-IgnoreUserFilter"
                    switch
                  >
                    <span v-if="item.boxConfig.IgnoreUserFilter">{{ $t('Yes') }}</span>
                    <span v-if="!item.boxConfig.IgnoreUserFilter">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

          </template>
          <template v-if="item.boxConfig.type === 'custom'">

            <!-- Custom Calculations -->
            <b-row>
              <b-col>
                <b-form-group
                  :label="$t('Custom Calculation')"
                  label-for="mc-box-customCalculation"
                >
                  <v-select
                    id="mc-box-customCalculation"
                    v-model="item.boxConfig.customCalculation"
                    :options="optionCustomCalculation"
                    :placeholder="$t('Select...')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

          </template>

        </app-collapse-item>
        <app-collapse-item
          v-if="item.projectId && (item.boxConfig.type === 'score' || item.boxConfig.type === 'standard' || item.boxConfig.type === 'frequency' || item.boxConfig.type === 'custom')"
          :title="$t('Display Properties')"
        >

          <!-- Display -->
          <b-row>
            <b-col>
              <b-form-group
                :label="$t('Display')"
                label-for="mc-box-display"
              >
                <v-select
                  id="mc-box-display"
                  v-model="item.boxConfig.display"
                  :options="fixedDisplayOptions"
                  :clearable="false"
                  :placeholder="$t('Select...')"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="item.boxConfig.display === 'bar' || item.boxConfig.display === 'column'">
              <b-form-group
                :label="$t('Stacking')"
                label-for="mc-box-stacking"
              >
                <v-select
                  id="mc-box-stacking"
                  v-model="item.boxConfig.stacking"
                  :options="displayOptions.stacking"
                  :placeholder="$t('Select...')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            v-if="item.boxConfig.display !== 'table' && item.boxConfig.display !== 'pie' && item.boxConfig.display !== 'treemap'"
          >
            <!-- Axis Min -->
            <b-col>
              <b-form-group
                :label="$t('Axis Min')"
                label-for="axisMin"
              >
                <b-form-input
                  id="axisMin"
                  v-model="item.boxConfig.axisMin"
                  :type="'number'"
                  :placeholder="$t('Auto')"
                />
              </b-form-group>
            </b-col>
            <!-- Axis Max -->
            <b-col>
              <b-form-group
                :label="$t('Axis Max')"
                label-for="axisMax"
              >
                <b-form-input
                  id="axisMax"
                  v-model="item.boxConfig.axisMax"
                  :type="'number'"
                  :placeholder="$t('Auto')"
                />
              </b-form-group>
            </b-col>
            <!-- Target Line -->
            <b-col>
              <b-form-group
                :label="$t('Target Line')"
                label-for="targetLine"
              >
                <b-form-input
                  id="targetLine"
                  v-model="item.boxConfig.targetLine"
                  :type="'number'"
                  :placeholder="$t('None')"
                />
              </b-form-group>
            </b-col>
            <!-- Target Line Color -->
            <b-col v-if="item.boxConfig.targetLine">
              <b-form-group
                :label="$t('Target Line Color')"
                label-for="targetLineColor"
              >
                <b-form-input
                  v-model="item.boxConfig.targetLineColor"
                  type="color"
                  :placeholder="$t('Color...')"
                />
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <!-- Transpose Chart -->
            <b-col
              v-if="item.boxConfig.type !== 'custom'"
              md="3"
            >
              <b-form-group
                :label="$t('Transpose Chart?')"
                label-for="transposeChart"
              >
                <b-form-checkbox
                  id="transposeChart"
                  v-model="item.boxConfig.transposeChart"
                  class="mt-1"
                  name="transposeChart"
                  switch
                >
                  <span v-if="item.boxConfig.transposeChart">{{ $t('Yes') }}</span>
                  <span v-if="!item.boxConfig.transposeChart">{{ $t('No') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- ShowBaseOnChartItems -->
            <b-col
              v-if="item.boxConfig.showBase && item.boxConfig.transposeChart"
              md="3"
            >
              <b-form-group
                :label="$t('Show Bases?')"
                label-for="showBaseOnChartItems"
              >
                <b-form-checkbox
                  id="showBaseOnChartItems"
                  v-model="item.boxConfig.showBaseOnChartItems"
                  class="mt-1"
                  name="showBaseOnChartItems"
                  switch
                >
                  <span v-if="item.boxConfig.showBaseOnChartItems">{{ $t('Yes') }}</span>
                  <span v-if="!item.boxConfig.showBaseOnChartItems">{{ $t('No') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- Color Total -->
            <b-col
              md="3"
            >
              <b-form-group
                :label="$t('Color Total')"
                label-for="colorTotal"
              >
                <b-form-input
                  v-model="item.boxConfig.colorTotal"
                  type="color"
                  :placeholder="$t('Color...')"
                />
              </b-form-group>
            </b-col>
            <!-- Color YTD -->
            <b-col
              md="3"
            >
              <b-form-group
                :label="$t('Color YTD')"
                label-for="colorYTD"
              >
                <b-form-input
                  v-model="item.boxConfig.colorYTD"
                  type="color"
                  :placeholder="$t('Color...')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="item.boxConfig.display !== 'table' && item.boxConfig.display !== 'treemap'">
            <b-row>
              <!-- Color -->
              <b-col md="8">
                <b-form-group
                  :label="$t('Color')"
                  label-for="color"
                >
                  <b-form-input
                    v-model="color"
                    type="color"
                    :placeholder="$t('Color...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Button -->
              <b-col md="4">
                <b-button
                  class="mt-2"
                  variant="primary"
                  @click="addColor"
                >
                  {{ $t('OK') }}
                </b-button>
                <b-button
                  v-if="editColorIndex > -1"
                  class="mt-2 ml-1"
                  variant="secondary"
                  @click="removeColor"
                >
                  {{ $t('Delete') }}
                </b-button>
              </b-col>
            </b-row>
            <span v-if="item.boxConfig.colors && item.boxConfig.colors.length > 0">

              <draggable
                v-model="item.boxConfig.colors"
                class="cursor-move"
              >
                <span
                  v-for="(colorItem, index) in item.boxConfig.colors"
                  :key="index"
                  style="cursor:pointer;"
                  @click="editColor(index)"
                >
                  <b-badge
                    :style="'background-color:' + colorItem"
                    class="mr-1 mt-1"
                  >&nbsp;
                  </b-badge>
                </span>

              </draggable>
            </span>
          </template>
          <template v-if="item.boxConfig.display === 'treemap'">
            <!-- color steps -->
            <h5 class="mt-1">
              {{ $t('Color Steps') }}
            </h5>
            <b-row>
              <!-- From -->
              <b-col>
                <b-form-group
                  :label="$t('From')"
                  label-for="from"
                >
                  <b-form-input
                    v-model="colorStep.from"
                    type="number"
                    :placeholder="$t('From...')"
                  />
                </b-form-group>
              </b-col>
              <!-- To -->
              <b-col>
                <b-form-group
                  :label="$t('To')"
                  label-for="to"
                >
                  <b-form-input
                    v-model="colorStep.to"
                    type="number"
                    :placeholder="$t('To...')"
                  />
                </b-form-group>
              </b-col>
              <!-- Name -->
              <b-col>
                <b-form-group
                  :label="$t('Name')"
                  label-for="name"
                >
                  <b-form-input
                    v-model="colorStep.name"
                    :placeholder="$t('Name...')"
                  />
                </b-form-group>

              </b-col>
              <!-- Color -->
              <b-col>
                <b-form-group
                  :label="$t('Color')"
                  label-for="color"
                >
                  <b-form-input
                    v-model="colorStep.color"
                    type="color"
                    :placeholder="$t('Color...')"
                  />
                </b-form-group>
              </b-col>

              <!-- Button -->
              <b-col>
                <b-button
                  class="mt-2"
                  variant="primary"
                  @click="addColorStep"
                >
                  {{ $t('OK') }}
                </b-button>
              </b-col>
            </b-row>
            <b-list-group v-if="item.boxConfig.colorSteps && item.boxConfig.colorSteps.length > 0">

              <draggable
                v-model="item.boxConfig.colorSteps"
                class="cursor-move"
              >
                <b-list-group-item
                  v-for="(step, index) in item.boxConfig.colorSteps"
                  :key="index"
                  class="flex-column align-items-start"
                >
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">
                      <b-badge
                        :style="'background-color:' + step.color"
                        class="mr-1"
                      >&nbsp;
                      </b-badge>{{ step.name }}
                      <small class="ml-1">{{ step.from }} - {{ step.to }}</small>
                    </h5>
                    <small>
                      <b-link @click="removeColorStep(index)">{{ $t('delete') }}</b-link>
                    </small>
                  </div>
                </b-list-group-item>
              </draggable>

            </b-list-group>

          </template>

        </app-collapse-item>

        <app-collapse-item
          v-if="item.boxConfig.type !== 'external' && item.boxConfig.type !== 'custom'"
          :title="$t('Filter Properties')"
        >
          <form-filter
            v-if="item.projectId"
            v-model="item.boxConfig.filterConfig.filters"
            :project-id="item.projectId"
          />

        </app-collapse-item>

      </app-collapse>

    </b-form>

  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import QuestionOrder from '@/layouts/components/QuestionOrder.vue'

import {
  BFormGroup, BForm, BFormInput, BRow, BCol, BFormCheckbox, BFormTextarea, BTable, BCardText, BCard, BAvatar, BButton, BListGroup, BListGroupItem, BLink, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import FormFilter from '@/layouts/components/forms/FormFilter.vue'
import IconSelector from '@/layouts/components/IconSelector.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    QuestionOrder,
    AppCollapse,
    AppCollapseItem,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BCol,
    BFormCheckbox,
    BFormTextarea,
    BTable,
    vSelect,
    FormFilter,
    IconSelector,
    BCardText,
    BCard,
    BAvatar,
    BButton,
    BListGroup,
    BListGroupItem,
    BLink,
    BBadge,
    draggable,
  },
  directives: {
    Ripple,
  },
  props: {
    pageId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        drilledBy: 0,
        boxTitle: null,
        projectId: null,
        pageId: null,
        orderNumber: 1,
        configJson: null,
        config: null,
        boxWidth: 12,
        boxHeight: 500,
        boxConfig: {
          sigTest: 0,
          sigTestType: 'All',
          type: 'score',
          showBase: true,
          showOptionsBase: false,
          showUnweightedBase: false,
          showGeneral: false,
          showCumulative: false,
          showYearToDate: false,
          comparePeriods: false,
          addTrendColor: false,
          decimalPlaces: 2,
          currentYearMinusN: 0,
          questionNames: [],
          infoQuestionNames: [],
          groupNames: [],
          visibleOptions: [],
          breakByQuestionName: null,
          filterConfigJson: null,
          filterConfig: { filters: [] },
          statisticIcon: 'SmileIcon',
          statisticType: 'score',
          layout: 'vertical',
          statisticVariant: 'success',
          statisticOption: null,
          columnOperator: null,
          infographics: [],
          display: 'table',
          percentage: 'no',
          colorSteps: [],
          colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5', '#03A9F4', '#4CAF50', '#F9CE1D', '#FF9800', '#33B2DF', '#546E7A', '#D4526E', '#13D8AA', '#A5978B', '#4ECDC4', '#C7F464', '#81D4FA', '#546E7A', '#FD6A6A', '#2B908F', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7', '#449DD1', '#F86624', '#EA3546', '#662E9B', '#C5D86D', '#D7263D', '#1B998B', '#2E294E', '#F46036', '#E2C044', '#662E9B', '#F86624', '#F9C80E', '#EA3546', '#43BCCD', '#5C4742', '#A5978B', '#8D5B4C', '#5A2A27', '#C4BBAF', '#A300D6', '#7D02EB', '#5653FE', '#2983FF', '#00B1F2'],
          orderByScore: false,
          includeListData: false,
          topNItem: 0,
          ignoreUserFilterNLevel: 0,
          showStdDev: false,
          showMean: false,
          meanOnly: false,
          ignoreUserFilterForFreq: false,
          ignoreUserFilter: false,
        },
        description: null,
      },
      ig: {
        size: 4,
        statisticIcon: 'SmileIcon',
        statisticType: 'score',
        statisticVariant: 'success',
        statisticOption: null,
        columnOperator: null,
        showBase: true,
        includeListData: false,
      },
      required,
      initialUserGroups: [],
      optionProject: [],
      optionPage: [],
      optionWidth: [4, 6, 8, 12],
      optionHeight: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      optionType: ['standard', 'score', 'frequency', 'data', 'external', 'infographic', 'infographicGroup', 'custom'],
      optionLayout: ['vertical', 'horizontal', 'donut'],
      optionLayoutWithMap: ['vertical', 'horizontal', 'donut', 'map-tr'],

      optionSigTest: [0, 90, 95],
      optionSigTestType: ['All', 'Up/Down', 'Total'],
      optionTopBottom: [0, 2, 3],
      optionQuestion: [],
      optionScoreDefinition: [],
      externalDataPaste: null,
      optionStatisticSize: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      optionStatisticType: ['score', 'frequency'],
      optionQuestionChoice: [],
      ig_optionQuestionChoice: [],
      autoTitleFlag: false,
      editInfographicIndex: -1,
      displayOptions: {
        type: ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie', 'treemap'],
        // type: ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie', 'treemap', 'waterfall'],
        stacking: ['percent', 'normal'],
      },
      optionUserGroup: [],
      colorStep: {
        from: null, to: null, name: null, color: '#000000',
      },
      color: '#000000',
      editColorIndex: -1,
    }
  },
  computed: {
    fixedDisplayOptions() {
      if (this.item.boxConfig.type !== 'frequency') {
        return ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie']
        // return ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie', 'waterfall']
      }
      return ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie', 'treemap']
      // return ['table', 'bar', 'column', 'line', 'spline', 'area', 'pie', 'treemap', 'waterfall']
    },
    optionStatisticVariant() {
      const variantList = ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light-primary', 'light-secondary', 'light-success', 'light-warning', 'light-danger', 'light-info']
      if (this.item.boxConfig.layout === 'donut') { return [...['dynamic'], ...variantList] }
      return variantList
    },
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
    optionPercent() {
      const question = this.getQuestion(this.item.boxConfig.questionName)
      let opts = ['no']
      if (question) {
        if (question.questionType === 1 || question.questionType === 0) {
          opts = [...opts, 'by base']
        }
        if (question.questionType === 4) {
          opts = [...opts, 'by base', 'by total response']
        }
      }
      if (this.item.boxConfig.breakByQuestionName) {
        opts = [...opts, 'by row']
      }
      return opts
    },
    optionScoreDefinitionSelected() {
      return this.item.boxConfig.groupNames
    },
    optionQuestionsWithOutNumeric() {
      return this.optionQuestion.filter(x => x.questionType !== 3)
    },
    optionQuestionNumeric() {
      return this.optionQuestion.filter(x => x.questionType === 3)
    },
    selectedQuestionType() {
      if (this.item.boxConfig.questionName) {
        const question = this.optionQuestion.find(q => q.questionName === this.item.boxConfig.questionName)
        if (question) {
          return question.questionType
        }
        return -1
      }
      return -1
    },
    ig_selectedQuestionType() {
      if (this.ig.questionName) {
        const question = this.optionQuestion.find(q => q.questionName === this.ig.questionName)
        if (question) {
          return question.questionType
        }
        return -1
      }
      return -1
    },
    optionColumnOperator() {
      if (this.item.boxConfig.questionName) {
        const question = this.optionQuestion.find(q => q.questionName === this.item.boxConfig.questionName)
        let opts = []
        if (question) {
          switch (question.questionType) {
            case 0: // text
            case 2: // text
              opts = ['Count', 'Percent']
              break
            case 1: // single
            case 4: // multi
              opts = ['Avg', 'Sum', 'Count', 'Percent']
              break
            case 3: // numeric
              opts = ['Avg', 'Sum']
              break
            default:
              break
          }
          return opts
        }
      }

      return []
    },
    ig_optionColumnOperator() {
      if (this.ig.questionName) {
        const question = this.optionQuestion.find(q => q.questionName === this.ig.questionName)
        let opts = []
        if (question) {
          switch (question.questionType) {
            case 0: // text
            case 2: // text
              opts = ['Count', 'Percent']
              break
            case 1: // single
            case 4: // multi
              opts = ['Avg', 'Sum', 'Count', 'Percent']
              break
            case 3: // numeric
              opts = ['Avg', 'Sum']
              break
            default:
              break
          }
          return opts
        }
      }

      return []
    },
  },
  async created() {
    this.item.pageId = this.pageId
    this.getProjectOptions()
    this.getUserGroupOptions()
    this.getPageOptions()
    // this.getQuestionOptions()
    await this.projectChanged()
  },
  methods: {
    handlePercentage() {
      if (this.item.boxConfig.questionName) {
        const question = this.getQuestion(this.item.boxConfig.questionName)
        if ((!this.item.boxConfig.breakByQuestionName && this.item.boxConfig.percentage === 'by row') || question.questionType === 3) {
          this.item.boxConfig.percentage = 'no'
        }
        if (question.questionType !== 4 && this.item.boxConfig.percentage === 'by total response') {
          this.item.boxConfig.percentage = 'by base'
        }
      }
    },
    getPageOptions() {
      const menu = this.$store.state.verticalMenu.menuLinks
      this.optionPage = []
      menu.forEach(item => {
        if (!item.children.length) {
          this.optionPage.push({ id: item.id, title: this.$t(item.title) })
        } else {
          item.children.forEach(c => {
            if (!c.children.length) {
              this.optionPage.push({ id: c.id, title: `${this.$t(item.title)}/${this.$t(c.title)}` })
            } else {
              c.children.forEach(cc => {
                this.optionPage.push({ id: cc.id, title: `${this.$t(item.title)}/${this.$t(c.title)}/${this.$t(cc.title)}` })
              })
            }
          })
        }
      })
    },
    getUserGroupOptions() {
      useJwt.axiosIns.get('usergroup').then(response => {
        this.optionUserGroup = response.data
      })
    },
    getQuestion(questionName) {
      return this.optionQuestion.find(q => q.questionName === questionName)
    },
    resetEditingInfographic() {
      this.editInfographicIndex = -1

      this.ig = {
        size: 4,
        statisticIcon: 'SmileIcon',
        statisticType: 'score',
        statisticVariant: 'success',
        statisticOption: null,
        columnOperator: null,
        showBase: true,
        includeListData: false,
      }
    },
    editInfographicItem(ig, index) {
      this.editInfographicIndex = index
      this.ig = JSON.parse(JSON.stringify(ig))
      this.ig_getQuestionChoiceOptions()
    },
    deleteInfographicItem(index) {
      this.editInfographicIndex = -1
      this.item.boxConfig.infographics.splice(index, 1)
    },
    addInfographic() {
      if (this.editInfographicIndex > -1) {
        this.item.boxConfig.infographics[this.editInfographicIndex] = JSON.parse(JSON.stringify(this.ig))
      } else {
        this.item.boxConfig.infographics.push(JSON.parse(JSON.stringify(this.ig)))
      }
      this.resetEditingInfographic()
    },
    addColorStep() {
      this.item.boxConfig.colorSteps.push(JSON.parse(JSON.stringify(this.colorStep)))
      this.colorStep = {
        from: null, to: null, name: null, color: '#000000',
      }
    },
    removeColorStep(index) {
      this.item.boxConfig.colorSteps.splice(index, 1)
    },
    addColor() {
      if (this.editColorIndex > -1) {
        this.item.boxConfig.colors[this.editColorIndex] = JSON.parse(JSON.stringify(this.color))
      } else {
        this.item.boxConfig.colors.push(JSON.parse(JSON.stringify(this.color)))
      }
      this.editColorIndex = -1
    },
    editColor(index) {
      this.editColorIndex = index
      this.color = this.item.boxConfig.colors[this.editColorIndex]
    },
    removeColor() {
      this.item.boxConfig.colors.splice(this.editColorIndex, 1)
      this.editColorIndex = -1
    },
    selectIcon() {
      this.$bvModal.show('iconSelector')
    },
    setIcon(icon) {
      this.$bvModal.hide('iconSelector')
      this.item.boxConfig.statisticIcon = icon
    },
    ig_setIcon(icon) {
      this.$bvModal.hide('iconSelector')
      this.ig.statisticIcon = icon
    },
    async parseTabularData() {
      this.item.boxConfig.externalData = { fields: [], items: [] }

      if (this.externalDataPaste) {
        const lines = this.externalDataPaste.split('\n')
        const fields = lines[0].split('\t')
        const items = []
        let headerFlag = false
        lines.forEach(element => {
          if (!headerFlag) {
            headerFlag = true
          } else {
            const newRow = {}
            fields.forEach(h => {
              newRow[h] = element.split('\t')[fields.indexOf(h)]
            })
            items.push(newRow)
          }
        })
        this.item.boxConfig.externalData = { fields, items }
      }
    },
    async projectChanged() {
      this.getQuestionOptions()
      this.getScoreDefinitionOptions()
      this.getCustomCalculationOptions()
      if (this.item.boxConfig.questionName) {
        this.getQuestionChoiceOptions()
      }
      if (this.ig.questionName) {
        this.ig_getQuestionChoiceOptions()
      }
    },
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    getQuestionOptions() {
      this.optionQuestion = []
      if (this.item.projectId) {
        useJwt.axiosIns.get(`question/${this.item.projectId}/shortlist`).then(response => {
          this.optionQuestion = response.data
        })
      }
    },
    getQuestionChoiceOptions() {
      if (this.item.projectId && this.item.boxConfig.questionName) {
        if (!this.item.boxTitle || this.autoTitleFlag) {
          this.autoTitleFlag = true
          this.item.boxTitle = this.optionQuestion.find(q => q.questionName === this.item.boxConfig.questionName).questionText
        }
        useJwt.axiosIns.get(`questionoption/${this.item.projectId}/${this.item.boxConfig.questionName}/shortlist`).then(response => {
          this.optionQuestionChoice = response.data
        })
      }
    },
    ig_getQuestionChoiceOptions() {
      if (this.item.projectId && this.ig.questionName) {
        useJwt.axiosIns.get(`questionoption/${this.item.projectId}/${this.ig.questionName}/shortlist`).then(response => {
          this.ig_optionQuestionChoice = response.data
        })
      }
    },
    handleTitle() {
      if (this.item.boxConfig.groupName) {
        if (!this.item.boxTitle || this.autoTitleFlag) {
          this.autoTitleFlag = true
          this.item.boxTitle = this.item.boxConfig.groupName
        }
      }
    },
    getScoreDefinitionOptions() {
      this.optionScoreDefinition = []
      if (this.item.projectId) {
        useJwt.axiosIns.get(`scoredefinition/${this.item.projectId}/shortlist`).then(response => {
          this.optionScoreDefinition = response.data
        })
      }
    },
    getCustomCalculationOptions() {
      this.optionCustomCalculation = []
      if (this.item.projectId) {
        useJwt.axiosIns.get(`customcalculation/${this.item.projectId}/shortlist`).then(response => {
          this.optionCustomCalculation = response.data
        })
      }
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = JSON.parse(JSON.stringify(this.item))

          // corrections here!
          if (!postItem.boxConfig.breakByQuestionName) {
            postItem.boxConfig.sigTest = 0
            postItem.boxConfig.showCumulative = false
            postItem.boxConfig.showYearToDate = false
          }
          if (postItem.boxConfig.type !== 'external') {
            delete postItem.boxConfig.externalData
          }
          if (postItem.boxConfig.type === 'frequency') {
            postItem.boxConfig.questionNames = []
            postItem.boxConfig.infoQuestionNames = []
            if (postItem.boxConfig.percentage === 'by total response') {
              postItem.boxConfig.showTotalResponseRow = true
            }
            if (postItem.boxConfig.percentage !== 'by base') {
              postItem.boxConfig.showUnweightedBase = false
            }
          }
          if (postItem.boxConfig.type === 'data') {
            postItem.boxConfig.breakByQuestionName = null
            postItem.boxConfig.infoQuestionNames = []
            postItem.boxConfig.display = 'table'
          }
          if (postItem.boxConfig.type === 'score' || postItem.boxConfig.type === 'standard') {
            postItem.boxConfig.questionName = null
          }
          if (postItem.boxConfig.display === 'pie') {
            postItem.boxConfig.transposeChart = false
          }
          if (this.selectedQuestionType === 0) {
            postItem.boxConfig.showMean = false
            postItem.boxConfig.showStdDev = false
            postItem.boxConfig.meanOnly = false
          }
          if (!postItem.boxConfig.showMean) {
            postItem.boxConfig.meanOnly = false
          }
          if (postItem.boxConfig.meanOnly) {
            postItem.boxConfig.showStdDev = false
          }
          if (this.selectedQuestionType !== 1 && this.selectedQuestionType !== 4) {
            postItem.boxConfig.top = 0
            postItem.boxConfig.bottom = 0
          }
          if (this.selectedQuestionType !== 4) {
            postItem.boxConfig.showTotalResponseRow = false
          }
          if (postItem.boxConfig.type === 'custom') {
            postItem.boxConfig.showBase = false
            // postItem.boxConfig.display = 'table'
          }

          if (postItem.boxConfig.sigTest === null) {
            postItem.boxConfig.sigTest = 0
          }

          if (postItem.boxConfig.orderByAsc === null) {
            postItem.boxConfig.orderByAsc = false
          }

          if (postItem.boxConfig.layout !== 'donut' && postItem.boxConfig.statisticVariant === 'dynamic') {
            postItem.boxConfig.statisticVariant = 'primary'
          }

          if (postItem.boxConfig.showMean === null) {
            postItem.boxConfig.showMean = false
          }
          if (!postItem.boxConfig.currentYearMinusN) {
            postItem.boxConfig.currentYearMinusN = 0
          }

          postItem.configJson = JSON.stringify(postItem.boxConfig)
          if (postItem.id) {
            useJwt.axiosIns.patch('box', postItem)
              .then(response => {
                if (response.data) {
                  if (response.data === -1) {
                    this.$swal({
                      title: this.$t('Error'),
                      text: this.$t('This page has reached box limit!'),
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonText: this.$t('OK'),
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                      buttonsStyling: false,
                    }).then(() => {
                    })
                  } else {
                    this.$emit('submit', postItem.id)
                  }
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('box', postItem)
              .then(response => {
                if (response.data) {
                  if (response.data === -1) {
                    this.$swal({
                      title: this.$t('Error'),
                      text: this.$t('This page has reached box limit!'),
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonText: this.$t('OK'),
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                      buttonsStyling: false,
                    }).then(() => {
                    })
                  } else {
                    this.$emit('submit', response.data)
                    if (postItem.drilledBy) {
                      this.$emit('drillAdded', postItem.drilledBy)
                    }
                  }
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
